import React, { useMemo } from 'react';
import { getErrorMessageFromObj } from '../../../../core/utils/request';
import { HdIcon } from '../../../../components';

export function ObjectExplorerFeildsFetchError({
  error
}: { error: any }) {
  const errorMessage = useMemo(() => getErrorMessageFromObj(error), [error]);
  
  return (
    <div className='no-item-box errored'>
      <div className='no-item-box-icon-container'>
        <HdIcon name='error-filled' className='no-item-box-icon'/>
      </div>

      <p className='no-item-box-title'>
        {errorMessage}
      </p>
    </div>
  );
}
